<div class="col-lg-6 col-md-8 col-sm-10 col-lg-offset-3 col-md-offset-2 col-sm-offset-1 push-up-50 push-down-50">
  <div class="panel-auth">
    <div class="auth-header">
      <br /><br />
      <div class="page-title">Account Sign In</div>
      <br /><br /><br />
    </div>

    <h5 class="panel-title push-down-20">Please enter your login details</h5>

    <div id="mbalertbox" class="mb-alert-box mb-alertbox-hide"></div>

    <form [formGroup]="myForm" (ngSubmit)="onSubmit()">
      <div class="push-up-30">
        <div class="col-sm-10 col-sm-offset-1 push-down-20">
          <div class="form-elem">
            <div class="form-elem-name">Email Address</div>
            <div class="form-elem-field">
              <input type="text" [formControl]="myForm.controls['username']" [(ngModel)]="model.username" />
              <div class="mb-error-fail-wrap" *ngIf="!myForm.controls['username'].valid && myForm.controls['username'].touched"><div class="mb-error-fail">Please enter your User name</div></div>
            </div>
          </div>
        </div>

        <div class="clear"></div>

        <div class="col-sm-10 col-sm-offset-1">
          <div class="form-elem">
            <div class="form-elem-name">Password</div>
            <div class="form-elem-field">
              <input type="password" [formControl]="myForm.controls['password']" [(ngModel)]="model.password" />
              <div class="mb-error-fail-wrap" *ngIf="!myForm.controls['password'].valid && myForm.controls['password'].touched"><div class="mb-error-fail">Please enter your Password</div></div>
            </div>
          </div>
        </div>

        <div class="clear"></div>

        <div class="col-sm-8 col-sm-offset-2 push-down-20">
          <button class="btn-main-proceed-alt" type="submit" [disabled]="!myForm.valid">Log in</button>
          <div class="push-down-10 submit-content"><a routerLink="/forgotten">Forgot Password?</a></div>
        </div>

        <div class="clear"></div>
      </div>
    </form>
  </div>
</div>

<div class="clear"></div>
